export enum SituacaoEnum {
    ATIVO = "Ativo",
    INATIVO = "Inativo"
}